(function ($) {
  let main = {
    init: function () {
      this.events()
    },

    events: function () {
        this.accordion(".module-faqs__details");
        this.accordion(".panel__details");
        this.accordion(".product-info__accordion");
    },

    accordion: function (selector) {
          // Fetch all the details element.
          const details = document.querySelectorAll(selector);
          console.log('test', details)

          
          // Add the onclick listeners.
          details.forEach((detail) => {
              detail.addEventListener("toggle", () => {
                  if (detail.open) this.setTargetDetail(detail, details);
              });
          });
    },

    setTargetDetail: function(targetDetail, allDetails) {
          allDetails.forEach((detail) => {
              if (detail !== targetDetail) {
                  detail.open = false;
              }
          });
    }
  }

  $(document).ready(function () {
    main.init()
  })

})(jQuery)
